//Localhost
export const LOCALHOST = process.env.REACT_APP_URL_LOCAL;

//Auth
export const SIGNIN = '/';

export const EXPIRATIONTOKEN = '/expirationtoken';

export const PAGENOTFOUND = '/*';

//Home
export const HOME = '/home';

//Users
export const USERS = '/users';
export const USERLIST = '/users/list';
export const USERNEW = '/users/new';
export const USEREDIT = '/users/edit';

//Survey
export const SURVEY_PATH = '/survey';
export const SURVEYNEW = '/surveys/new';
export const SURVEYEDIT = '/surveys/edit';

//Export
export const EXPORT = '/export';
